/* eslint-disable prettier/prettier */
import { Input } from "@twilio-paste/core/input";
import { Label } from "@twilio-paste/core/label";
import { Box } from "@twilio-paste/core/box";
import { Option, Select, UnorderedList, ListItem } from "@twilio-paste/core";
import { FormEvent } from "react";
// import { Button } from "@twilio-paste/core/button";
import { useDispatch, useSelector } from "react-redux";
import { Text } from "@twilio-paste/core/text";

import { sessionDataHandler } from "../sessionDataHandler";
import { addNotification, changeEngagementPhase, updatePreEngagementData } from "../store/actions/genericActions";
import { initSession } from "../store/actions/initActions";
import { AppState, EngagementPhase } from "../store/definitions";
import { Header } from "./Header";
import { notifications } from "../notifications";
import { NotificationBar } from "./NotificationBar";
import {
    introStyles,
    fieldStyles,
    formStyles,
    buttonStyles,
    scheduleBoxStyles,
    scheduleListStyles,
    scheduleItemStyles,
    boxContainerStyles
} from "./styles/PreEngagementFormPhase.styles";

export const PreEngagementFormPhase = () => {
    const { name, email, query } = useSelector((state: AppState) => state.session.preEngagementData) || {};
    const dispatch = useDispatch();

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        dispatch(changeEngagementPhase({ phase: EngagementPhase.Loading }));
        try {
            const data = await sessionDataHandler.fetchAndStoreNewSession({
                formData: {
                    friendlyName: name,
                    email,
                    query
                }
            });
            dispatch(initSession({ token: data.token, conversationSid: data.conversationSid }));
        } catch (err) {
            dispatch(addNotification(notifications.failedToInitSessionNotification((err as Error).message)));
            dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
        }
    };

    /* const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {*/
    /*  if (e.key === "Enter" && !e.shiftKey) {*/
    /*      e.preventDefault();*/
    /*      handleSubmit(e);*/
    /*     }*/
    /* };*/

    return (
        <>
            <Header />
            <NotificationBar />
            <Box as="form" data-test="pre-engagement-chat-form" onSubmit={handleSubmit} {...formStyles}>
                {/* <Text {...titleStyles} as="h3">
                    Echangez en direct avec un conseiller
                </Text> */}
                <Text {...introStyles} as="p">
                    Notre équipe est là pour vous aider. Avant de commencer, dites-nous-en un peu plus.
                </Text>
                {/* <Box {...fieldStyles}>
                    <Label htmlFor="name">Quel est votre nom ?</Label>
                    <Input
                        type="text"
                        placeholder="Entrez votre nom"
                        name="name"
                        data-test="pre-engagement-chat-form-name-input"
                        value={name}
                        onChange={(e) => dispatch(updatePreEngagementData({ name: e.target.value }))}
                        required
                    />
                </Box> */}
                <Box {...fieldStyles}>
                    <Label htmlFor="query">Quel est votre besoin ?</Label>
                    <Select
                        name="query"
                        data-test="pre-engagement-chat-form-query-textarea"
                        value={query}
                        // defaultValue="Deco"
                        onChange={(e) => dispatch(updatePreEngagementData({ query: e.target.value }))}
                        required
                    >
                        <Option value="" disabled>
                            -- Sélectionnez une option --
                        </Option>
                        <Option value="Deco">Une question déco</Option>
                        <Option value="Technique">Un conseil sur un produit</Option>
                        <Option value="Commande">Un suivi de commande</Option>
                        <Option value="Reclamation">Un souci avec un produit</Option>
                    </Select>
                </Box>
                <Box {...fieldStyles}>
                    <Label htmlFor="email">Quel est votre email ?</Label>
                    <Input
                        type="email"
                        placeholder="Entrez votre adresse email"
                        name="email"
                        data-test="pre-engagement-chat-form-email-input"
                        value={email}
                        onChange={(e) => dispatch(updatePreEngagementData({ email: e.target.value }))}
                        required
                    />
                </Box>
                <Box {...boxContainerStyles}>
                <Box
                    as="button"
                    data-test="pre-engagement-start-chat-button"
                    type="submit"
                    title="Démarrer une conversation"
                    {...buttonStyles}
                >
                    Démarrer la conversation
                </Box>
                </Box>

                <Box {...scheduleBoxStyles}>
                    <Text as="p">Le service conseil de Libéron est ouvert :</Text>
                    <UnorderedList {...scheduleListStyles}>
                        <ListItem {...scheduleItemStyles}>Lundi : 9h-12h30 / 13h30-17h30</ListItem>
                        <ListItem {...scheduleItemStyles}>Mardi : 10h30-12h30 / 13h30-17h30</ListItem>
                        <ListItem {...scheduleItemStyles}>Mercredi : 9h-12h30 / 13h30-17h30</ListItem>
                        <ListItem {...scheduleItemStyles}>Jeudi : 9h-12h30 / 13h30-17h30</ListItem>
                        <ListItem {...scheduleItemStyles}>Vendredi : 9h-12h30 / 13h30-17h30</ListItem>
                    </UnorderedList>
                </Box>
            </Box>
            {/* <Button variant="primary" type="submit" data-test="pre-engagement-start-chat-button">
                        Démarrer la conversation !
                    </Button> */}
        </>
    );
};
